import { useToggleIDTagging } from '@msdk/common'
import { ReactNode } from 'react'

export function IdTaggingWrapper({ children }: { children?: ReactNode | undefined }) {
  useToggleIDTagging()

  return children
}
